export default "__VITE_ASSET__8zWmnJlB__"